import React, { useRef, useState } from 'react';
import { mergeStyles } from '@uifabric/merge-styles';
import { PortalWrapper } from 'portal-wrapper';
import { TooltipBaseProps, TooltipProps } from '../schema/Tooltip.types';
import { useSafeComponentTimeout } from 'mini-hooks/lib/useSafeComponentTimeout';
import { useTooltipPosition } from '../hooks/useTooltipPosition';

const styles = require('./Tooltip.scss');
const classNames = require('classnames/bind').bind(styles);

const TooltipBase = (props: TooltipBaseProps) => {
    const toolTip = useRef(null);
    const {
        placement = 'bottom',
        onDismiss,
        timeout,
        anchorRef,
        position,
        arrowPosition,
        content,
        tooltipStyle,
        onDragHandler,
        ariaAttributes,
    } = props;
    const [visible, setVisible] = useState(true);
    const state = useTooltipPosition({ placement, anchorRef, toolTip, position, arrowPosition });
    const { x, y, arrowLeft } = state;
    const visibility = visible ? styles.on : styles.off;
    const style = {
        left: `${x}px`,
        top: `${y}px`,
        ...tooltipStyle,
    };
    useSafeComponentTimeout(() => {
        setVisible(false);
        onDismiss && onDismiss();
    }, timeout);

    return (
        <div
            data-testId={'TooltipTestId'}
            ref={toolTip}
            className={classNames(mergeStyles(styles[placement], visibility, styles.tooltip))}
            style={style}
            onDrag={onDragHandler}
            {...ariaAttributes}>
            <div className={styles.tooltipArrow} style={{ left: `${arrowLeft}px` }} />
            <div className={styles.tooltipLabel}>{content}</div>
        </div>
    );
};

const Tooltip = (props: TooltipProps) => {
    const { tooltipId, ...baseProps } = props;

    return (
        <PortalWrapper divOrIdToAttachTo={tooltipId}>
            <TooltipBase {...baseProps} />
        </PortalWrapper>
    );
};

export { Tooltip, TooltipBase };
